<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      _beforeUnload_time: '',
      _gap_time: ''
    }
  },
  mounted() {
    window.addEventListener('beforeunload', e => {
      this._beforeUnload_time = new Date().getTime()
    })
    window.addEventListener('unload', async () => {
      this._gap_time = new Date().getTime() - this._beforeUnload_time
      if (this._gap_time <= 5) {
        //关闭
        //清除 cookie 或者 localStorage 的方法
        localStorage.removeItem("token")
        localStorage.removeItem("name")
        localStorage.removeItem('uname')
      } else {
        // 刷新
      }
    })
  },
  destroyed() {
    window.removeEventListener('beforeunload')
    window.removeEventListener('unload')
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue